// extracted by mini-css-extract-plugin
export var blink = "_7h-2";
export var cursor = "_7h-1";
export var reactMarkdown = "_7h-3";
export var streamingText = "_7h-0";